import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'o2web-react-core';

// Props & context
const propTypes = {
  children: PropTypes.node.isRequired,
  path: PropTypes.string.isRequired,
  title: PropTypes.string,
  className: PropTypes.string,
  lang: PropTypes.oneOf(['fr', 'en']),
};
const defaultProps = {
  className: '',
  title: '',
  lang: 'fr',
};
const contextTypes = {
  t: PropTypes.func,
};

function CustomLink(props, { t }) {
  const {
    children,
    path,
    title,
    className,
    lang,
  } = props;
  return (
    <React.Fragment>
      {/^https?:\/\//.test(path) ?
        <a
          href={path}
          title={title}
          className={className}
        >
          {t(`pages.${children}.title`).startsWith('pages.') ? children : t(`pages.${children}.title`)}
        </a>
        :
        <NavLink
          to={`${lang}/${path}`}
          title={title}
          className={className}
        >
          {t(`pages.${children}.title`).startsWith('pages.') ? children : t(`pages.${children}.title`)}
        </NavLink>
      }
    </React.Fragment>
  );
}

CustomLink.propTypes = propTypes;
CustomLink.defaultProps = defaultProps;
CustomLink.contextTypes = contextTypes;

export default CustomLink;



// WEBPACK FOOTER //
// ./src/app/components/tools/customLink/CustomLink.js